<template>
	<li>
		<router-link class="tf-nc" :to="{ name: 'EquipmentDetail', params: { id: getEqName(node.parent_id) }}" v-if="node.parent_id != ''">
			<img width="55" v-lazy="'/static/images/equipment/icon_equipment_'+ node.parent_id +'.png'">
			<span class="consume" v-if="node.consume">
				x {{node.consume}}
			</span>
		</router-link>
		<ul v-if="node.children && node.children.length">
			<node v-for="child in node.children" :node="child" :key="node.parent_id"></node>
		</ul>
	</li>
</template>
<script>
export default {
	name: "node",
	props: {
		node: Object
	},
	methods: {
		getEqName: function(eq_id) {
			var self = this;
			var eq = _.find(self.$store.getters.getEquipmentCraft, function(o) {
				return o.condition_equipment_id_1 == eq_id;
			});
			if (eq) {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq.equipment_id;
				});
				return eqData.equipment_name;
			} else {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq_id;
				});
				return eqData.equipment_name;
			}
		},
	},
	mounted: function() {}
};
</script>